const updateAdditionalItems = (json, cartItems) => {
  const additionProductsWrapper = document.querySelector(
    '.additional-products',
  );
  const additionalProductsList = document.querySelector(
    '.additional-products-list',
  );

  if (json && json.length) {
    if (
      additionProductsWrapper &&
      additionProductsWrapper.classList.contains('hidden')
    ) {
      additionProductsWrapper.classList.remove('hidden');
    }
  } else if (additionProductsWrapper) {
    additionProductsWrapper.classList.add('hidden');
  }

  if (additionalProductsList) {
    additionalProductsList.innerHTML = '';

    const items = json.map((additional) => {
      const sauceInCart = cartItems.find(
        (item) => item.productId === additional.id,
      );

      let additionItemId;

      if (sauceInCart) {
        additionItemId = sauceInCart.id;
      } else {
        additionItemId = additional.id;
      }

      return `<li class="additional-item row" data-id="${additionItemId}" data-price="${
        additional.price
      }">
          <div class="sauce row">
            <div class="sauce-color-wrapper">
              <div class="sauce-color" style="background: #${
                additional.color
              }"></div>
            </div>
            <div class="sauce-text small-text">
              <div>${additional.name} <span>${
        additional.price / 100
      } ₽</span></div>
            </div>
          </div>
          <button type="button" class="add-additional very-small-text ${
            sauceInCart ? 'hidden' : ''
          }">Добавить</button>
          <div class="count-button row ${sauceInCart ? 'visible' : ''}">
            <button type="button" class="count-control minus">
              <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 0V2H0V0H12Z" fill="#A3A3A3"/></svg>
            </button>
            <input type="number" class="count-input base-text bold" value="${
              sauceInCart ? `${sauceInCart.quantity}` : '1'
            }"/>
            <button type="button" class="count-control plus ${
              sauceInCart && sauceInCart.quantity === 99 ? 'disabled' : ''
            }">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 12H5L5 0L7 8.74228e-08L7 12Z" fill="#838383"/><path d="M12 5V7H0V5H12Z" fill="#838383"/></svg>
            </button>
          </div>
          <div class="addition-product-price base-text bold ${
            sauceInCart ? 'visible' : ''
          }">
            ${
              sauceInCart &&
              `<span>${
                (sauceInCart.quantity * additional.price) / 100
              }</span> ₽`
            }
          </div>
        </li>`;
    });

    additionalProductsList.innerHTML = items.join('');
  }
};

export default updateAdditionalItems;
